import { ReactNode } from "react";
import { Link } from "react-router-dom";

const ConditionalLink: any = ({ to, children }: { to: string; children: ReactNode }) =>
    to ? <Link to={to}>{children}</Link> : children;

export default ConditionalLink;
